// Android i iOS zwykle nie uruchamiają aplikacji od nowa, tylko wznawiają ją z tła
// (albo przywracają ostatnio otwartą stronę). Po dłuższej przerwie traktujemy powrót
// do aplikacji jak jej otwarcie: ekran szybkiego wyboru (/start), a gdy jest wyłączony —
// rozmowa z asystentem. Krótkie przełączenie (np. skopiowanie czegoś z innej aplikacji)
// nie przerywa pracy.
import { isStandalone, launcherEnabled } from '@/composables/useLauncher.js'

const AWAY_MS = 15 * 60 * 1000
const NO_RETURN = ['/login', '/register', '/reset-password', '/polityka-prywatnosci']

export default defineNuxtPlugin(() => {
    if (!isStandalone()) return

    const router = useRouter()
    let hiddenAt: number | null = null

    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
            hiddenAt = Date.now()
            return
        }
        const away = hiddenAt != null ? Date.now() - hiddenAt : 0
        hiddenAt = null
        if (away < AWAY_MS) return

        // Bez przeskoku na stronę, na której już jesteśmy, i na stronach bez logowania.
        const target = launcherEnabled() ? '/start' : '/'
        const path = router.currentRoute.value.path
        if (path === target || NO_RETURN.includes(path)) return
        router.push(target)
    })
})
